import Image from 'next/legacy/image'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import tw, { styled } from 'twin.macro'

const StyledAvatar = styled.div<{ $big: boolean; $extraSmall?: boolean }>(
  ({ $big, $extraSmall }) => [
    tw`transform bg-accentroWhite-200 mr-px-4 rounded-full flex justify-center items-center relative overflow-hidden md:ml-px-12`,
    $big ? tw`scale-150` : tw`scale-100`,
    $extraSmall
      ? tw`h-px-40 w-px-40 md:(m-0 h-px-32 w-px-32) lg:(h-px-48 w-px-48)`
      : tw`h-px-48 w-px-48 `,
  ]
)

const StyledAvatarWrapper = styled.div<{ $big: boolean }>(({ $big }) => [
  $big ? tw`` : tw``,
])

const StyledHead = styled.div<{ $extraSmall?: boolean }>(({ $extraSmall }) => [
  tw`bg-yellow-100 rounded-full`,
  $extraSmall
    ? tw`h-px-16 w-px-16 md:(h-px-8 w-px-8) lg:(h-px-16 w-px-16)`
    : tw`h-px-16 w-px-16`,
])
const StyledBody = styled.div<{ $extraSmall?: boolean }>(({ $extraSmall }) => [
  tw`absolute bg-gray-300 bottom-0 rounded-full`,
  $extraSmall
    ? tw`-mb-px-16 h-px-32 w-px-32 md:(h-px-16 w-px-16 -mb-px-4) lg:(-mb-px-16 h-px-32 w-px-32)`
    : tw`-mb-px-16 h-px-32 w-px-32`,
])

export const BrokerAvatar: FunctionComponent<
  React.PropsWithChildren<{
    url?: string | null
    big?: boolean
    extraSmall?: boolean
  }>
> = ({ url, big, extraSmall }) => {
  return (
    <StyledAvatarWrapper $big={!!big}>
      <StyledAvatar $big={!!big} $extraSmall={extraSmall}>
        <StyledHead $extraSmall={extraSmall} />
        <StyledBody $extraSmall={extraSmall} />
        {url && (
          <Image
            tw="absolute object-cover"
            layout={'fill'}
            src={url}
            alt={'broker avatar image'}
          />
        )}
      </StyledAvatar>
    </StyledAvatarWrapper>
  )
}
